module.exports = "/images/Peras-loja.png?98d355bcac5f97860a0711a8f93e5f4b";